import { combineReducers } from 'redux'
import appeal from '../reducers/appealReducers'
import admin from '../reducers/adminReducers'
export default combineReducers({
  appeal,
  admin
})



// WEBPACK FOOTER //
// ./src/modules/index.js